<template>
  <ul class="tool-controls list-reset inline-block controls" v-if="controls.isVisible">
    <li class="refresh" v-if="controls.isRefresh">
      <button type="button" class=" btn btn-grid-toolbar-style btn-size-s" @click.prevent="handlerCommand('refresh')">
        <i class="fa fa-sync-alt refresh"/>
        {{L10n('refresh')}}
      </button>
    </li>
    <li class="excel tool-controls__drop-dawn-menu-button" v-if="isVisibleExport">
      <div class="btn btn-grid-toolbar-style btn-size-s">
        <i class="fas fa-download"/>
        {{L10n('export')}}
      </div>
      <ul>
        <li
          v-if="isVisibleExcel"
          @mouseenter.prevent.stop="handlerHover"
        >
          {{L10n('excel')}}
          <ul :class="[dropClassName]">
            <li
              v-if="isVisibleExcelCurrent"
              @click.prevent="handlerCommand('excelCurrent')">
              {{controls.export.excel.current.titleBtn}}
            </li>
            <li
              v-if="isVisibleExcelAll"
              @click.prevent="handlerCommand('excelAll')">
              {{controls.export.excel.all.titleBtn}}
            </li>
          </ul>
        </li>
        <li
          v-if="isVisibleJSON"
          @mouseenter.prevent.stop="handlerHover"
        >
          {{L10n('json')}}
          <ul :class="[dropClassName]">
            <li
              v-if="isVisibleJSONCurrent"
              @click.prevent="handlerCommand('jsonCurrent')">
              {{controls.export.json.current.titleBtn}}
            </li>
            <li
              v-if="isVisibleJSONAll"
              @click.prevent="handlerCommand('jsonAll')">
              {{controls.export.json.all.titleBtn}}
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li class="add-new" v-if="controls.addNew.isVisible">
      <button type="button" class="btn btn-grid-toolbar-style btn-size-s" @click.prevent="handlerCommand('addNew')">
        <i class="fas fa-plus"></i>
        {{controls.addNew.title}}
      </button>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'GridToolControls',
  props: { controls: { type: Object } },
  computed: {
    permissions () {
      return this.$store.getters.get('permissions')
    },
    isVisibleExport () {
      return this.controls.export.isVisible && (this.isVisibleJSON || this.isVisibleExcel)
    },
    // Excel visible
    isVisibleExcel () {
      return this.permission(this.permissions, this.controls.export.excel.permission) &&
        (this.isVisibleExcelCurrent || this.isVisibleExcelAll)
    },
    isVisibleExcelCurrent () {
      return this.controls.export.excel.current.isVisible
    },
    isVisibleExcelAll () {
      return this.controls.export.excel.all.isVisible
    },
    // JSON visible
    isVisibleJSON () {
      return this.isVisibleJSONCurrent || this.isVisibleJSONAll
    },
    isVisibleJSONCurrent () {
      return this.controls.export.json.current.isVisible
    },
    isVisibleJSONAll () {
      return this.controls.export.json.all.isVisible
    }
  },
  data () {
    return {
      dropClassName: 'right',
      limitLengthToWindowBorder: 100
    }
  },
  methods: {
    handlerCommand (Command) {
      this.$emit('command', Command)
    },
    // TODO: КОСТЫЛЬ НУЖНО СДЕЛАТЬ ОТДЕЛЬНЫЙ КОМПОНЕНТ ДЛЯ DROPDOWN
    handlerHover (e) {
      const { right } = e.target.getBoundingClientRect()
      const windowWidth = window.innerWidth
      this.dropClassName = (windowWidth - right) > this.limitLengthToWindowBorder
        ? 'right' : 'left'
    }
  }
}
</script>
<style lang="stylus">
  ul.controls{
    &.tool-controls{
      list-style none
      padding 0
      margin 0
      > li {
        padding .5rem 0 .5rem 1rem
        display inline-block
        vertical-align top

        > .btn-grid-toolbar-style {
          position relative

          .fas {
            padding-left .2rem
          }
        }
      }
      ul {
        list-style none
        position absolute
        margin 0
        padding 0
        box-shadow 0 0 5px 1px rgba(0, 0, 0, 0.1)
        border-radius .25rem
        background #fff
        display none
        min-width 7rem
        z-index 10
        li {
          padding 1rem
          margin 0
          text-align left
          position relative
          white-space nowrap
          color #797b81
          font-weight 400
          font-size 1.2rem
          line-height 1.1
          text-transform none

          &:first-letter {
            text-transform uppercase
          }

          &:hover {
            background #f2f2f2
            color #1b2138
          }
        }
      }
    }
    .tool-controls{
      &__drop-dawn-menu-button{
        position relative
        &:hover,
        &:focus {
          > ul {
            top 100%
            right 0
            display block
            &:before,
            &:after {
              content ''
              border-left 6px solid transparent
              border-right 6px solid transparent
              border-bottom 6px solid #fff
              position absolute
              bottom 100%
              right 15%
            }

            &:before {
              border-bottom-color #dcdcdc
              bottom calc(100% + 1px)
            }
            > li {
              > ul {
                top 0
                border-radius 0 .25rem .25rem .25rem

                &.left {
                  right 100%
                }

                &.right {
                  left 100%
                }
              }

              &:hover {
                > ul {
                  display block
                }
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 576px) {
    ul.controls{
      &.tool-controls{
        display flex
        justify-content space-around
        padding 1rem 0 0 0 !important
        width 100%
        flex-wrap wrap
        > li {
          margin 0
          padding 1rem 0
          width 100%
          .btn {
            width 100%
          }
        }
      }
    }
  }
</style>
